<template>
  <imgix-image :sizes="sizes" :imgixParams="imgixParamsWithAdditional" :path="path" :alt="alt" :loading="loading" :spinnerSize="spinnerSize" :spinnerColor="spinnerColor" />
</template>

<script>
import { defineAsyncComponent } from "vue";
const ImgixImage = defineAsyncComponent(() => import("@/components/imgix-image.vue"));

export default {
  components: {
    ImgixImage,
  },

  props: {
    alt: {
      type: String,
      default: "Product Image",
    },

    productId: {
      type: Number,
      default: null,
    },

    variantId: {
      type: Number,
      default: null,
    },

    lineItemId: {
      type: Number,
      default: null,
    },

    default: {
      type: Boolean,
      default: false,
    },

    detail: {
      type: Boolean,
      default: false,
    },

    index: {
      type: Number,
      default: null,
    },

    hash: {
      type: String,
      default: null,
    },

    imgixParams: {
      type: Object,
      default: () => {},
    },

    submissionFallback: {
      type: Boolean,
      default: false,
    },

    poster: {
      type: Boolean,
      default: false,
    },

    isLineItem: {
      type: Boolean,
      default: false,
    },

    sizes: {
      type: [String],
      default: "(min-width: 600px) 50vw, (min-width: 900px) 33vw, 100vw",
    },

    loading: {
      type: String,
      default: "lazy",
    },

    spinnerSize: {
      type: String,
      default: "48",
    },

    spinnerColor: {
      type: String,
      default: "#ff523f",
    },
  },

  computed: {
    path() {
      let imagePath = "mockup";

      return imagePath;
    },

    imgixParamsWithAdditional() {
      let params = { ...this.imgixParams };

      if (this.variantId !== null) {
        params.vid = this.variantId;

        if (this.detail) {
          params.detail = this.detail ? 1 : 0;
        }

        if (this.poster) {
          params.poster = this.poster ? 1 : 0;
        }

        if (this.index !== null) {
          params.index = this.index;
        }
      } else if (this.productId !== null) {
        params.pid = this.productId;

        if (this.default) {
          params.default = this.default ? 1 : 0;
        }

        if (this.detail) {
          params.detail = this.detail ? 1 : 0;
        }

        if (this.poster) {
          params.poster = this.poster ? 1 : 0;
        }

        if (this.index !== null) {
          params.index = this.index;
        }

        if (this.submissionFallback) {
          params.submissionFallback = this.submissionFallback ? 1 : 0;
        }
      } else if (this.lineItemId !== null) {
        params.lid = this.lineItemId;

        if (this.detail) {
          params.detail = this.detail ? 1 : 0;
        }

        if (this.index !== null) {
          params.index = this.index;
        }
      }

      if (this.hash !== null) {
        params.hash = this.hash;
      }

      return params;
    },
  },
};
</script>
